import React, { createContext } from 'react';

export const BoxContext = createContext({
	boxCondition: null,
	setBoxCondition: () => {},
});